module.exports = __webpack_public_path__ + "img/photo-16.6cc29781.jpg";